
<div class="wrapper" *ngIf="!retailer || spinnerShown">
    <mat-progress-spinner class="inner" 
        mode="indeterminate"></mat-progress-spinner>
</div>
<mat-card *ngIf="retailer && !spinnerShown">
    <!-- <mat-card-header> -->
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title>
          <mat-form-field class="input-full-width" [style.width.px]=400>
            <mat-label>Name</mat-label>
            <input matInput type="text" [(ngModel)]="retailer.name" />
          </mat-form-field>
        </mat-card-title>
        <mat-card-subtitle>
            <mat-form-field class="input-full-width" [style.width.px]=400>
                <mat-label>Description</mat-label>
                <input matInput type="text" [(ngModel)]="retailer.description" />
            </mat-form-field>
        </mat-card-subtitle>
        <mat-card-subtitle>
            <mat-form-field class="input-full-width" [style.width.px]=400>
                <mat-label>Visible In App</mat-label>
                <mat-select [(ngModel)]="retailer.visibility">
                    <mat-option value="private">No</mat-option>
                    <mat-option value="public">Yes</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card-subtitle>
        <mat-card-subtitle>
            <mat-form-field class="input-full-width" appearance="fill">
                <mat-label>Business Categories</mat-label>
                <mat-chip-list #chipList aria-label="Category selection">
                  <mat-chip
                    *ngFor="let cat of retailer.categoryIds"
                    [selectable]="false"
                    [removable]="true"
                    (removed)="removeCat(cat)">
                    {{getCat(cat).name}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input
                    placeholder="Add category..."
                    #catInput
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addCat($event)">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedCat($event)">
                  <mat-option *ngFor="let cat of filteredCats" [value]="cat.id">
                    {{cat.name}}
                  </mat-option>
                </mat-autocomplete>

              </mat-form-field>

        </mat-card-subtitle>
        
    <!-- </mat-card-header> -->
    
    <mat-card-content>
        <h1>Images</h1>
        <!-- <mat-card> -->
            <h4>Large Image</h4>
            <ngp-image-picker
            [_config]="largeImagePickerConf"
            [_imageSrc]="retailer.largeImageUrl"
            ($imageChanged)="onLargeImageChange($event)"
          ></ngp-image-picker>
       <h1>Links <button mat-button class="inline-button" (click)="addLink()"><mat-icon>note_add</mat-icon></button></h1>
       <div class="url-container">
        <mat-list class="mat-elevation-z2">
            <mat-list-item *ngIf="(retailer.links||[]).length == 0">No Links Added</mat-list-item>
            <mat-list-item *ngFor="let link of retailer.links"><app-retailer-link [link]="link"></app-retailer-link><button mat-button class="inline-button" (click)="removeLink(link)"><mat-icon style="color: red;">delete</mat-icon></button></mat-list-item>
        </mat-list>
        
      </div>

        <div *ngIf="!isNew">
        <h2>Offers <button mat-button class="inline-button" [routerLink]="[ 'offers', 'new']"><mat-icon>note_add</mat-icon></button></h2>
        
        <app-offers-list [retailer]="retailer" [offers]="offers"></app-offers-list>
        
        <h2 class="locations-header">Locations <button mat-button class="inline-button" (click)="addLocation()"><mat-icon>note_add</mat-icon></button></h2>
        <div class="locations-container " >
            
            
                
            <mat-expansion-panel class="offers-subpanel" *ngFor="let loc of retailer.locations" [expanded]="!loc.id"  >
                <!-- (afterExpand)="loationExpanded(loc)" -->
                <mat-expansion-panel-header>                
                    <div class="location-title" [class.deleted]="loc.isDeleted">{{loc|locationFormat}}</div>   
                        
                </mat-expansion-panel-header>
                <!-- <mat-progress-spinner class="inner" *ngIf="!loc.offers"  mode="indeterminate"></mat-progress-spinner> -->
                <div>
                <mat-card>
            <app-location (locationDeleted)="locationDeleted($event)" [location]="loc" *ngIf="!loc.isDeleted"></app-location>
            <div *ngIf="loc.isDeleted">Location is deleted. <button mat-button color="warn" (click)="loc.isDeleted = false" >Undelete</button></div>
                </mat-card>
                </div>
                
                
            </mat-expansion-panel>
    

                
                <!-- <mat-selection-list [miltiple]="false">
                    <mat-list-option *ngFor="let loc of retailer.locations">
                        {{ makeDisplayAddress(loc) }}
                    </mat-list-option>
                </mat-selection-list> -->
            </div>            
        </div>
        <div *ngIf="isNew">
            Save this retailer to add new locations and offers.
        </div>
    </mat-card-content>
    <mat-card-actions align="end">
        <button mat-button (click)="save()">SAVE</button>
        <div style="flex: 1 1 auto;"></div>
        <button *ngIf="!isNew" mat-button color="warn" (click)="delete()">DELETE BUSINESS</button>
    </mat-card-actions>
</mat-card>
